import React, { useEffect, useState } from "react";
import {
  achtourphotoslist,
  allcmsresourcelist,
  exteventphotoslist,
  photoslist,
  storyview,
} from "../../../../services/superadmin";
import { funderlist, schoollistmaster } from "../../../../services/master";
import Select from "react-select";
import { cmstaglist } from "../../../../services/common";
import { Col, Row } from "react-bootstrap";
import dotracking from "../../../trackinglogs";
import trackobj from "../../../trackingpages.json";
import { funderreportpublish } from "../../../../services/funder";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import moment from "moment";
import { tourdetails } from "../../../../services/register";
import Carousel, { Modal, ModalGateway } from "react-images";

export const AllResouces = () => {
  const [reslist, setResList] = useState([]);

  const [respath, setResPath] = useState("");
  const [sdate, setSDate] = useState("");
  const [edate, setEDate] = useState("");
  const [tagid, setTagId] = useState([]);
  const [schid, setSchId] = useState([]);

  const [slist, setSList] = useState([]);
  const [tlist, setTList] = useState([]);

  const [funid, setFunId] = useState([]);
  const [flist, setFList] = useState([]);

  const [rtype, setRType] = useState("");

  const [tolist, setToList] = useState([]);

  const [sslist, setSSList] = useState([]);
  const [spath, setSPath] = useState("");

  useEffect(() => {
    allcmsresourcelist("", "", "", "", "", "").then((res) => {
      if (res.status === true) {
        setResPath(res.data.logo_path);
        setSPath(res.data.success_story_path);

        setSSList(res.data.success_stories);
        setResList(res.data.all_resources);

        let arr = [];
        if (res.data.tournament_list_school.length !== 0) {
          for (let i = 0; i < res.data.tournament_list_school.length; i++) {
            arr.push({
              id: res.data.tournament_list_school[i].id,
              meet_name: res.data.tournament_list_school[i].meet_name,
              start_date: res.data.tournament_list_school[i].start_date,
              end_date: res.data.tournament_list_school[i].end_date,
              categories: res.data.tournament_list_school[i].categories,
              sports_type: res.data.tournament_list_school[i].sports_type,
              tournament_logo:
                res.data.tournament_list_school[i].tournament_logo,
              tournament_path: res.data.tournament_logo_path,
              type: "Tournament",
              gallery: false,
              extract: "",
            });
          }
        }

        if (res.data.all_ext_tournament_list_school.length !== 0) {
          for (
            let i = 0;
            i < res.data.all_ext_tournament_list_school.length;
            i++
          ) {
            arr.push({
              id: res.data.all_ext_tournament_list_school[i].id,
              meet_name: res.data.all_ext_tournament_list_school[i].meet_name,
              start_date: res.data.all_ext_tournament_list_school[i].start_date,
              end_date: res.data.all_ext_tournament_list_school[i].end_date,
              categories: res.data.all_ext_tournament_list_school[i].categories,
              sports_type:
                res.data.all_ext_tournament_list_school[i].sports_type,
              tournament_logo:
                res.data.all_ext_tournament_list_school[i].tournament_logo,
              tournament_path: res.data.tournament_logo_path,
              type: "External",
              gallery: false,
              extract: "",
            });
          }
        }

        if (res.data.event_list_school.length !== 0) {
          for (let i = 0; i < res.data.event_list_school.length; i++) {
            arr.push({
              id: res.data.event_list_school[i].id,
              meet_name: res.data.event_list_school[i].event_name,
              start_date: res.data.event_list_school[i].start_date,
              end_date: res.data.event_list_school[i].end_date,
              categories: res.data.event_list_school[i].event_age_category,
              sports_type: "",
              tournament_logo: "",
              tournament_path: res.data.tournament_logo_path,
              type: "Event",
              gallery: false,
              extract: "",
            });
          }
        }

        if (res.data.all_achievement_tournament_list_school.length !== 0) {
          for (
            let i = 0;
            i < res.data.all_achievement_tournament_list_school.length;
            i++
          ) {
            arr.push({
              id: "",
              meet_name:
                res.data.all_achievement_tournament_list_school[i].meet_name,
              start_date:
                res.data.all_achievement_tournament_list_school[i].meet_date,
              end_date: "",
              categories:
                res.data.all_achievement_tournament_list_school[i].age_group,
              sports_type:
                res.data.all_achievement_tournament_list_school[i].sports_type,
              tournament_logo:
                res.data.all_achievement_tournament_list_school[i].imagename,
              tournament_path: res.data.achievement_logo_path,
              type: "Achievement",
              gallery: false,
              extract:
                res.data.all_achievement_tournament_list_school[i].extract,
            });
          }
        }
        setToList(arr);
        listgallery(arr);
      }
    });

    schoollistmaster().then((res) => {
      if (res.status === true) {
        let arr = [];
        for (var i = 0; i < res.data.details.length; i++) {
          arr.push({
            label: res.data.details[i].school_name,
            value: res.data.details[i].id,
          });
        }
        setSList(arr);
      }
    });

    funderlist().then((res) => {
      if (res.status === true) {
        let arr = [];
        for (var i = 0; i < res.data.funders_list.length; i++) {
          arr.push({
            label: res.data.funders_list[i].funder_name,
            value: res.data.funders_list[i].id,
          });
        }
        setFList(arr);
      }
    });
    cmstaglist().then((res) => {
      if (res.status === true) {
        let arr = [];
        for (var i = 0; i < res.data.tags_list.length; i++) {
          arr.push({
            label: res.data.tags_list[i].tag_name,
            value: res.data.tags_list[i].id,
          });
        }
        setTList(arr);
      }
    });
  }, []);

  function handleSch(e) {
    if (e === null) {
      setSchId([]);
    } else {
      setSchId(e);
    }
  }

  function handleTag(e) {
    if (e === null) {
      setTagId([]);
    } else {
      setTagId(e);
    }
  }

  function handleFun(e) {
    if (e === null) {
      setFunId([]);
    } else {
      setFunId(e);
    }
  }
  function search() {
    let sid = "";
    if (schid.length !== 0) {
      for (var i = 0; i < schid.length; i++) {
        if (sid == "") {
          sid = schid[i].value;
        } else {
          sid = sid + "," + schid[i].value;
        }
      }
    }

    let tid = "";
    if (tagid.length !== 0) {
      for (var i = 0; i < tagid.length; i++) {
        if (tid == "") {
          tid = tagid[i].value;
        } else {
          tid = tid + "," + tagid[i].value;
        }
      }
    }

    let fid = "";
    if (funid.length !== 0) {
      for (var i = 0; i < funid.length; i++) {
        if (fid == "") {
          fid = funid[i].value;
        } else {
          fid = fid + "," + funid[i].value;
        }
      }
    }
    setResList([]);
    setToList([]);
    allcmsresourcelist(sdate, edate, tid, sid, fid, rtype).then((res) => {
      if (res.status === true) {
        setSPath(res.data.success_story_path);

        setResPath(res.data.logo_path);
        setResList(res.data.all_resources);
        setSSList(res.data.success_stories);
        let arr = [];
        if (schid.length !== 0 && funid.length === 0) {
          if (res.data.tournament_list_school.length !== 0) {
            for (let i = 0; i < res.data.tournament_list_school.length; i++) {
              arr.push({
                id: res.data.tournament_list_school[i].id,
                meet_name: res.data.tournament_list_school[i].meet_name,
                start_date: res.data.tournament_list_school[i].start_date,
                end_date: res.data.tournament_list_school[i].end_date,
                categories: res.data.tournament_list_school[i].categories,
                sports_type: res.data.tournament_list_school[i].sports_type,
                tournament_logo:
                  res.data.tournament_list_school[i].tournament_logo,
                tournament_path: res.data.tournament_logo_path,
                type: "Tournament",
                gallery: false,
                extract: "",
              });
            }
          }

          if (res.data.all_ext_tournament_list_school.length !== 0) {
            for (
              let i = 0;
              i < res.data.all_ext_tournament_list_school.length;
              i++
            ) {
              arr.push({
                id: res.data.all_ext_tournament_list_school[i].id,
                meet_name: res.data.all_ext_tournament_list_school[i].meet_name,
                start_date:
                  res.data.all_ext_tournament_list_school[i].start_date,
                end_date: res.data.all_ext_tournament_list_school[i].end_date,
                categories:
                  res.data.all_ext_tournament_list_school[i].categories,
                sports_type:
                  res.data.all_ext_tournament_list_school[i].sports_type,
                tournament_logo:
                  res.data.all_ext_tournament_list_school[i].tournament_logo,
                tournament_path: res.data.tournament_logo_path,
                type: "External",
                gallery: false,
                extract: "",
              });
            }
          }

          if (res.data.event_list_school.length !== 0) {
            for (let i = 0; i < res.data.event_list_school.length; i++) {
              arr.push({
                id: res.data.event_list_school[i].id,
                meet_name: res.data.event_list_school[i].event_name,
                start_date: res.data.event_list_school[i].start_date,
                end_date: res.data.event_list_school[i].end_date,
                categories: res.data.event_list_school[i].event_age_category,
                sports_type: "",
                tournament_logo: "",
                tournament_path: res.data.tournament_logo_path,
                type: "Event",
                gallery: false,
                extract: "",
              });
            }
          }

          if (res.data.all_achievement_tournament_list_school.length !== 0) {
            for (
              let i = 0;
              i < res.data.all_achievement_tournament_list_school.length;
              i++
            ) {
              arr.push({
                id: "",
                meet_name:
                  res.data.all_achievement_tournament_list_school[i].meet_name,
                start_date:
                  res.data.all_achievement_tournament_list_school[i].meet_date,
                end_date: "",
                categories:
                  res.data.all_achievement_tournament_list_school[i].age_group,
                sports_type:
                  res.data.all_achievement_tournament_list_school[i]
                    .sports_type,
                tournament_logo:
                  res.data.all_achievement_tournament_list_school[i].imagename,
                tournament_path: res.data.achievement_logo_path,
                type: "Achievement",
                gallery: false,
                extract:
                  res.data.all_achievement_tournament_list_school[i].extract,
              });
            }
          }
        } else if (schid.length === 0 && funid.length !== 0) {
          if (res.data.tournament_list_funder.length !== 0) {
            for (let i = 0; i < res.data.tournament_list_funder.length; i++) {
              arr.push({
                id: res.data.tournament_list_funder[i].id,
                meet_name: res.data.tournament_list_funder[i].meet_name,
                start_date: res.data.tournament_list_funder[i].start_date,
                end_date: res.data.tournament_list_funder[i].end_date,
                categories: res.data.tournament_list_funder[i].categories,
                sports_type: res.data.tournament_list_funder[i].sports_type,
                tournament_logo:
                  res.data.tournament_list_funder[i].tournament_logo,
                tournament_path: res.data.tournament_logo_path,
                type: "Tournament",
                gallery: false,
                extract: "",
              });
            }
          }

          if (res.data.all_ext_tournament_list_funder.length !== 0) {
            for (
              let i = 0;
              i < res.data.all_ext_tournament_list_funder.length;
              i++
            ) {
              arr.push({
                id: res.data.all_ext_tournament_list_funder[i].id,
                meet_name: res.data.all_ext_tournament_list_funder[i].meet_name,
                start_date:
                  res.data.all_ext_tournament_list_funder[i].start_date,
                end_date: res.data.all_ext_tournament_list_funder[i].end_date,
                categories:
                  res.data.all_ext_tournament_list_funder[i].categories,
                sports_type:
                  res.data.all_ext_tournament_list_funder[i].sports_type,
                tournament_logo:
                  res.data.all_ext_tournament_list_funder[i].tournament_logo,
                tournament_path: res.data.tournament_logo_path,
                type: "External",
                gallery: false,
                extract: "",
              });
            }
          }

          if (res.data.event_list_funder.length !== 0) {
            for (let i = 0; i < res.data.event_list_funder.length; i++) {
              arr.push({
                id: res.data.event_list_funder[i].id,
                meet_name: res.data.event_list_funder[i].event_name,
                start_date: res.data.event_list_funder[i].start_date,
                end_date: res.data.event_list_funder[i].end_date,
                categories: res.data.event_list_funder[i].event_age_category,
                sports_type: "",
                tournament_logo: "",
                tournament_path: res.data.tournament_logo_path,
                type: "Event",
                gallery: false,
                extract: "",
              });
            }
          }

          if (res.data.all_achievement_tournament_list_funder.length !== 0) {
            for (
              let i = 0;
              i < res.data.all_achievement_tournament_list_funder.length;
              i++
            ) {
              arr.push({
                id: "",
                meet_name:
                  res.data.all_achievement_tournament_list_funder[i].meet_name,
                start_date:
                  res.data.all_achievement_tournament_list_funder[i].meet_date,
                end_date: "",
                categories:
                  res.data.all_achievement_tournament_list_funder[i].age_group,
                sports_type:
                  res.data.all_achievement_tournament_list_funder[i]
                    .sports_type,
                tournament_logo:
                  res.data.all_achievement_tournament_list_funder[i].imagename,
                tournament_path: res.data.achievement_logo_path,
                type: "Achievement",
                gallery: false,
                extract:
                  res.data.all_achievement_tournament_list_funder[i].extract,
              });
            }
          }
        } else if (schid.length !== 0 && funid.length !== 0) {
          if (res.data.tournament_list_school.length !== 0) {
            for (let i = 0; i < res.data.tournament_list_school.length; i++) {
              arr.push({
                id: res.data.tournament_list_school[i].id,
                meet_name: res.data.tournament_list_school[i].meet_name,
                start_date: res.data.tournament_list_school[i].start_date,
                end_date: res.data.tournament_list_school[i].end_date,
                categories: res.data.tournament_list_school[i].categories,
                sports_type: res.data.tournament_list_school[i].sports_type,
                tournament_logo:
                  res.data.tournament_list_school[i].tournament_logo,
                tournament_path: res.data.tournament_logo_path,
                type: "Tournament",
                gallery: false,
                extract: "",
              });
            }
          }
          if (res.data.tournament_list_funder.length !== 0) {
            for (let i = 0; i < res.data.tournament_list_funder.length; i++) {
              arr.push({
                id: res.data.tournament_list_funder[i].id,
                meet_name: res.data.tournament_list_funder[i].meet_name,
                start_date: res.data.tournament_list_funder[i].start_date,
                end_date: res.data.tournament_list_funder[i].end_date,
                categories: res.data.tournament_list_funder[i].categories,
                sports_type: res.data.tournament_list_funder[i].sports_type,
                tournament_logo:
                  res.data.tournament_list_funder[i].tournament_logo,
                tournament_path: res.data.tournament_logo_path,
                type: "Tournament",
                gallery: false,
                extract: "",
              });
            }
          }

          if (res.data.all_ext_tournament_list_school.length !== 0) {
            for (
              let i = 0;
              i < res.data.all_ext_tournament_list_school.length;
              i++
            ) {
              arr.push({
                id: res.data.all_ext_tournament_list_school[i].id,
                meet_name: res.data.all_ext_tournament_list_school[i].meet_name,
                start_date:
                  res.data.all_ext_tournament_list_school[i].start_date,
                end_date: res.data.all_ext_tournament_list_school[i].end_date,
                categories:
                  res.data.all_ext_tournament_list_school[i].categories,
                sports_type:
                  res.data.all_ext_tournament_list_school[i].sports_type,
                tournament_logo:
                  res.data.all_ext_tournament_list_school[i].tournament_logo,
                tournament_path: res.data.tournament_logo_path,
                type: "External",
                gallery: false,
                extract: "",
              });
            }
          }
          if (res.data.all_ext_tournament_list_funder.length !== 0) {
            for (
              let i = 0;
              i < res.data.all_ext_tournament_list_funder.length;
              i++
            ) {
              arr.push({
                id: res.data.all_ext_tournament_list_funder[i].id,
                meet_name: res.data.all_ext_tournament_list_funder[i].meet_name,
                start_date:
                  res.data.all_ext_tournament_list_funder[i].start_date,
                end_date: res.data.all_ext_tournament_list_funder[i].end_date,
                categories:
                  res.data.all_ext_tournament_list_funder[i].categories,
                sports_type:
                  res.data.all_ext_tournament_list_funder[i].sports_type,
                tournament_logo:
                  res.data.all_ext_tournament_list_funder[i].tournament_logo,
                tournament_path: res.data.tournament_logo_path,
                type: "External",
                gallery: false,
                extract: "",
              });
            }
          }
          if (res.data.event_list_school.length !== 0) {
            for (let i = 0; i < res.data.event_list_school.length; i++) {
              arr.push({
                id: res.data.event_list_school[i].id,
                meet_name: res.data.event_list_school[i].event_name,
                start_date: res.data.event_list_school[i].start_date,
                end_date: res.data.event_list_school[i].end_date,
                categories: res.data.event_list_school[i].event_age_category,
                sports_type: "",
                tournament_logo: "",
                tournament_path: res.data.tournament_logo_path,
                type: "Event",
                gallery: false,
                extract: "",
              });
            }
          }
          if (res.data.event_list_funder.length !== 0) {
            for (let i = 0; i < res.data.event_list_funder.length; i++) {
              arr.push({
                id: res.data.event_list_funder[i].id,
                meet_name: res.data.event_list_funder[i].event_name,
                start_date: res.data.event_list_funder[i].start_date,
                end_date: res.data.event_list_funder[i].end_date,
                categories: res.data.event_list_funder[i].event_age_category,
                sports_type: "",
                tournament_logo: "",
                tournament_path: res.data.tournament_logo_path,
                type: "Event",
                gallery: false,
                extract: "",
              });
            }
          }
          if (res.data.all_achievement_tournament_list_school.length !== 0) {
            for (
              let i = 0;
              i < res.data.all_achievement_tournament_list_school.length;
              i++
            ) {
              arr.push({
                id: "",
                meet_name:
                  res.data.all_achievement_tournament_list_school[i].meet_name,
                start_date:
                  res.data.all_achievement_tournament_list_school[i].meet_date,
                end_date: "",
                categories:
                  res.data.all_achievement_tournament_list_school[i].age_group,
                sports_type:
                  res.data.all_achievement_tournament_list_school[i]
                    .sports_type,
                tournament_logo:
                  res.data.all_achievement_tournament_list_school[i].imagename,
                tournament_path: res.data.achievement_logo_path,
                type: "Achievement",
                gallery: false,
                extract:
                  res.data.all_achievement_tournament_list_school[i].extract,
              });
            }
          }
          if (res.data.all_achievement_tournament_list_funder.length !== 0) {
            for (
              let i = 0;
              i < res.data.all_achievement_tournament_list_funder.length;
              i++
            ) {
              arr.push({
                id: "",
                meet_name:
                  res.data.all_achievement_tournament_list_funder[i].meet_name,
                start_date:
                  res.data.all_achievement_tournament_list_funder[i].meet_date,
                end_date: "",
                categories:
                  res.data.all_achievement_tournament_list_funder[i].age_group,
                sports_type:
                  res.data.all_achievement_tournament_list_funder[i]
                    .sports_type,
                tournament_logo:
                  res.data.all_achievement_tournament_list_funder[i].imagename,
                tournament_path: res.data.achievement_logo_path,
                type: "Achievement",
                gallery: false,
                extract:
                  res.data.all_achievement_tournament_list_funder[i].extract,
              });
            }
          }
        } else if (schid.length === 0 && funid.length === 0) {
          if (res.data.tournament_list_school.length !== 0) {
            for (let i = 0; i < res.data.tournament_list_school.length; i++) {
              arr.push({
                id: res.data.tournament_list_school[i].id,
                meet_name: res.data.tournament_list_school[i].meet_name,
                start_date: res.data.tournament_list_school[i].start_date,
                end_date: res.data.tournament_list_school[i].end_date,
                categories: res.data.tournament_list_school[i].categories,
                sports_type: res.data.tournament_list_school[i].sports_type,
                tournament_logo:
                  res.data.tournament_list_school[i].tournament_logo,
                tournament_path: res.data.tournament_logo_path,
                type: "Tournament",
                gallery: false,
                extract: "",
              });
            }
          }

          if (res.data.all_ext_tournament_list_school.length !== 0) {
            for (
              let i = 0;
              i < res.data.all_ext_tournament_list_school.length;
              i++
            ) {
              arr.push({
                id: res.data.all_ext_tournament_list_school[i].id,
                meet_name: res.data.all_ext_tournament_list_school[i].meet_name,
                start_date:
                  res.data.all_ext_tournament_list_school[i].start_date,
                end_date: res.data.all_ext_tournament_list_school[i].end_date,
                categories:
                  res.data.all_ext_tournament_list_school[i].categories,
                sports_type:
                  res.data.all_ext_tournament_list_school[i].sports_type,
                tournament_logo:
                  res.data.all_ext_tournament_list_school[i].tournament_logo,
                tournament_path: res.data.tournament_logo_path,
                type: "External",
                gallery: false,
                extract: "",
              });
            }
          }

          if (res.data.event_list_school.length !== 0) {
            for (let i = 0; i < res.data.event_list_school.length; i++) {
              arr.push({
                id: res.data.event_list_school[i].id,
                meet_name: res.data.event_list_school[i].event_name,
                start_date: res.data.event_list_school[i].start_date,
                end_date: res.data.event_list_school[i].end_date,
                categories: res.data.event_list_school[i].event_age_category,
                sports_type: "",
                tournament_logo: "",
                tournament_path: res.data.tournament_logo_path,
                type: "Event",
                gallery: false,
                extract: "",
              });
            }
          }

          if (res.data.all_achievement_tournament_list_school.length !== 0) {
            for (
              let i = 0;
              i < res.data.all_achievement_tournament_list_school.length;
              i++
            ) {
              arr.push({
                id: "",
                meet_name:
                  res.data.all_achievement_tournament_list_school[i].meet_name,
                start_date:
                  res.data.all_achievement_tournament_list_school[i].meet_date,
                end_date: "",
                categories:
                  res.data.all_achievement_tournament_list_school[i].age_group,
                sports_type:
                  res.data.all_achievement_tournament_list_school[i]
                    .sports_type,
                tournament_logo:
                  res.data.all_achievement_tournament_list_school[i].imagename,
                tournament_path: res.data.achievement_logo_path,
                type: "Achievement",
                gallery: false,
                extract:
                  res.data.all_achievement_tournament_list_school[i].extract,
              });
            }
          }
        }
        setToList(arr);
        listgallery(arr);
      }
    });
  }

  function listgallery(larr) {
    if (larr.length !== 0) {
      for (let i = 0; i < larr.length; i++) {
        if (larr[i].type === "Tournament") {
          photoslist(larr[i].id).then((res) => {
            if (res.status === true) {
              if (res.data.tournamentlist.length !== 0) {
                larr[i].gallery = true;
                setToList([...larr]);
              }
            }
          });
        } else if (larr[i].type === "External") {
          exteventphotoslist(larr[i].id, 1).then((res) => {
            if (res.status === true) {
              if (res.data.tournamentlist.length !== 0) {
                larr[i].gallery = true;
                setToList([...larr]);
              }
            }
          });
        } else if (larr[i].type === "Event") {
          exteventphotoslist(larr[i].id, 2).then((res) => {
            if (res.status === true) {
              if (res.data.tournamentlist.length !== 0) {
                larr[i].gallery = true;
                setToList([...larr]);
              }
            }
          });
        } else if (larr[i].type === "Achievement") {
          const temp = new FormData();
          temp.append("tournament_name", larr[i].meet_name);
          temp.append("tournament_year", larr[i].extract);
          achtourphotoslist(temp).then((res) => {
            if (res.status === true) {
              if (res.data.tournamentlist.length !== 0) {
                larr[i].gallery = true;
                setToList([...larr]);
              }
            }
          });
        }
      }
    }
  }

  function openPLightbox(index, ilist) {
    handleclose();
    setCurrentImage(index);
    if (ilist.length !== 0) {
      setPPList(ilist);
    }

    setViewerIsOpen(true);
  }
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);
  const [pplist, setPPList] = useState([]);

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const [sshow, setSShow] = useState(false);
  const [stitle, setSTitle] = useState("");
  const [sdesc, setSDesc] = useState("");
  const [sphto, setSImage] = useState("");
  const [sdesc1, setSDesc1] = useState("");
  function handlestory(sid, stype) {
    storyview(sid).then((response) => {
      if (response.status === true) {
        setSShow(true);
        setSTitle(response.data.success_stories_details.article_title);
        setSDesc(response.data.success_stories_details.article_description);
        if (response.data.success_stories_details.article_image !== null) {
          setSImage(
            response.data.logo_path +
              response.data.success_stories_details.article_image
          );
        }

        setSDesc1(response.data.success_stories_details.article_content);
      }
    });
  }
  function handlesclose() {
    setSShow(false);
    setSTitle("");
    setSDesc("");
    setSImage("");
    setSDesc1("");
  }
  const [ishow, setIShow] = useState(false);
  const [pimage, setPImage] = useState(false);
  const [pimgtype, setPImgType] = useState("");
  const [pimgurl, setPImgUrl] = useState("");
  const [prem, setPRem] = useState("");
  const [ptag, setPTag] = useState("");
  const [psch, setPSch] = useState("");

  function handlepop(img, itype, ifile, irem, iname, isch) {
    if (itype === "Video") {
      if (ifile === "url") {
        let newstr1 = img.substr(img.length - 11);
        let curvideo = "";
        let res = img.substring(0, 23);
        curvideo = "https://www.youtube.com";
        if (curvideo == res) {
          setPImage(`https://www.youtube.com/embed/${newstr1}`);
        }
      } else {
        setPImage(respath + img);
      }
    } else {
      setPImage(respath + img);

      // setPImage(img+"#toolbar=0&navpanes=0&statusbar=0&view=Fit;readonly=true");
    }
    setPSch(isch);
    setPTag(iname);
    setPRem(irem);
    setPImgUrl(ifile);
    setIShow(true);
    setPImgType(itype);
  }

  function downloaded(iurl, ifile) {
    const link = document.createElement("a");
    link.setAttribute("target", "_blank");
    link.setAttribute("href", iurl);
    link.download = ifile;
    document.body.appendChild(link);
    link.click();
    link.remove();
    // const fileKey = iurl;
    // downloadFile(fileKey);
  }

  function imageclose() {
    setIShow(false);
    setPImage("");
    setPRem("");
    setPSch("");
    setPTag("");
  }

  function repstatus(list, litem) {
    if (list == 1) {
      Swal.fire({
        text: "Are you sure want to Private?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ac0404",
        cancelButtonColor: "#6259ca",
        confirmButtonText: "Private",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          dotracking(
            "publish status icon in funder report list from Publish to Private for " +
              litem.tag_name +
              " (" +
              litem.id +
              ") $$ " +
              trackobj.addreslist
          );
          funderreportpublish(localStorage.getItem("UID"), litem.id, 2).then(
            (response) => {
              if (response.status === true) {
                search();
                toast.success(response.message);
              }
            }
          );
        }
      });
    } else {
      Swal.fire({
        text: "Are you sure want to Publish?",
        icon: "success",
        showCancelButton: true,
        confirmButtonColor: "#008000",
        cancelButtonColor: "#6259ca",
        confirmButtonText: "Publish",
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          dotracking(
            "publish status icon in funder report list from Private to Publish for " +
              litem.tag_name +
              " (" +
              litem.id +
              ") $$ " +
              trackobj.addreslist
          );
          funderreportpublish(localStorage.getItem("UID"), litem.id, 1).then(
            (response) => {
              if (response.status === true) {
                search();
                toast.success(response.message);
              }
            }
          );
        }
      });
    }
  }
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage] = useState(10);

  const totalRecordsToShow = currentPage * recordsPerPage;
  const currentRecords = reslist.slice(0, totalRecordsToShow);

  const loadMore = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const [tourcurrentPage, setTourCurrentPage] = useState(1);

  const tourRecordsToShow = tourcurrentPage * recordsPerPage;
  const tourcurrentRecords = tolist.slice(0, tourRecordsToShow);

  const tourloadMore = () => {
    setTourCurrentPage((prevPage) => prevPage + 1);
  };

  const [sscurrentPage, setSSCurrentPage] = useState(1);

  const ssRecordsToShow = sscurrentPage * recordsPerPage;
  const sscurrentRecords = sslist.slice(0, ssRecordsToShow);

  const ssloadMore = () => {
    setSSCurrentPage((prevPage) => prevPage + 1);
  };

  const [show, setShow] = useState(false);
  const [glist, setGallery] = useState([]);
  const [gtour, setGTour] = useState("");

  function handleopen(cid) {
    if (cid.type === "Tournament") {
      photoslist(cid.id).then((res) => {
        if (res.status === true) {
          setShow(true);
          setGTour(cid.meet_name);
          if (res.data.tournamentlist.length !== 0) {
            let arr1 = [];
            for (let i = 0; i < res.data.tournamentlist.length; i++) {
              arr1.push({
                id: res.data.tournamentlist[i].id,
                src:
                  res.data.tournamentimage_path +
                  res.data.tournamentlist[i].imagename,
              });
            }
            setGallery(arr1);
          }
        }
      });
    } else if (cid.type === "External") {
      exteventphotoslist(cid.id, 1).then((res) => {
        if (res.status === true) {
          setShow(true);
          setGTour(cid.meet_name);
          if (res.data.tournamentlist.length !== 0) {
            let arr1 = [];
            for (let i = 0; i < res.data.tournamentlist.length; i++) {
              arr1.push({
                id: res.data.tournamentlist[i].id,
                src:
                  res.data.tournamentimage_path +
                  res.data.tournamentlist[i].imagename,
              });
            }
            setGallery(arr1);
          }
        }
      });
    } else if (cid.type === "Event") {
      exteventphotoslist(cid.id, 2).then((res) => {
        if (res.status === true) {
          setShow(true);
          setGTour(cid.meet_name);
          if (res.data.tournamentlist.length !== 0) {
            let arr1 = [];
            for (let i = 0; i < res.data.tournamentlist.length; i++) {
              arr1.push({
                id: res.data.tournamentlist[i].id,
                src:
                  res.data.tournamentimage_path +
                  res.data.tournamentlist[i].imagename,
              });
            }
            setGallery(arr1);
          }
        }
      });
    } else if (cid.type === "Achievement") {
      const temp = new FormData();
      temp.append("tournament_name", cid.meet_name);
      temp.append("tournament_year", cid.extract);
      achtourphotoslist(temp).then((res) => {
        if (res.status === true) {
          setShow(true);
          setGTour(cid.meet_name);
          if (res.data.tournamentlist.length !== 0) {
            let arr1 = [];
            for (let i = 0; i < res.data.tournamentlist.length; i++) {
              arr1.push({
                id: res.data.tournamentlist[i].id,
                src:
                  res.data.tournamentimage_path +
                  res.data.tournamentlist[i].imagename,
              });
            }
            setGallery(arr1);
          }
        }
      });
    }
  }
  function handleclose() {
    setShow(false);
    setGTour("");
    setGallery([]);
  }
  function errorhandle(ev) {
    ev.target.src = require("../../../../assets/images/resources/logo-pathway.png");
    ev.target.onerror = null;
  }
  function errortour(ev) {
    ev.target.src = require("../../../../assets/images/resources/logo_epl.png");
    ev.target.onerror = null;
  }

  function errorphoto(ev) {
    ev.target.src = require("../../../../assets/images/photo.png");
    ev.target.onerror = null;
  }
  const [tshow, setTShow] = useState(false);
  const [tdet, setTDet] = useState("");
  function handleShow(hid) {
    setTShow(true);
    setTDet(hid);
  }
  return (
    <div className="side-app">
      <div className="page-header">
        <div className="breadcrumb">
          <h4 className="mb-0">All Resources</h4>
        </div>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>CMS</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            All Resources
          </li>
        </ol>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-md-3">
            <div className="form-group">
              <label className="form-label">Start Date</label>
              <input
                type="date"
                className="form-control"
                value={sdate}
                onChange={(e) => setSDate(e.target.value)}
                // onBlur={search}
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label className="form-label">Ends Date</label>
              <input
                type="date"
                className="form-control"
                value={edate}
                onChange={(e) => setEDate(e.target.value)}
                // onBlur={search}
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label className="form-label">School</label>
              <Select
                className="dropdown"
                placeholder="Select School"
                value={schid}
                options={slist}
                onChange={handleSch}
                // onBlur={search}
                isSearchable={true}
                isMulti
                isClearable
                hidden
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label className="form-label">Tags</label>
              <Select
                className="dropdown"
                placeholder="Select Tags"
                value={tagid}
                options={tlist}
                onChange={handleTag}
                // onBlur={search}
                isSearchable={true}
                isMulti
                isClearable
                hidden
              />
            </div>
          </div>

          <div className="col-md-3">
            <div className="form-group">
              <label className="form-label">Funder</label>
              <Select
                className="dropdown"
                placeholder="Select Funder"
                value={funid}
                options={flist}
                onChange={handleFun}
                // onBlur={search}
                isSearchable={true}
                isMulti
                isClearable
                hidden
              />
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label className="form-label">Resources Type</label>
              <select
                className="form-control custom-select"
                value={rtype}
                onChange={(e) => setRType(e.target.value)}
              >
                <option value="" defaultValue>
                  --Select Resources Type--
                </option>
                {/* <option value="">All</option> */}
                <option value="Video">Video</option>
                <option value="Photo">Photo</option>
                <option value="PDF">PDF</option>
              </select>
            </div>
          </div>
          <div className="col-md-3"></div>
          <div className="col-md-3">
            <div className="form-group text-right">
              <a className="btn btn-success mt-6 mx-7 me-2" onClick={search}>
                Apply Filter
              </a>
            </div>
          </div>
        </div>
        {reslist.length == 0 && tolist.length == 0 && sslist.length == 0 && (
          <div className="container">
            <h3 className="text-center errortext">
              No resources available for the above selection
            </h3>
          </div>
        )}
        {tolist.length != 0 && (
          <div className="container mt-2">
            <div className="row gutter-y-30">
              <h4>Tournaments and Events</h4>

              {tourcurrentRecords.map((item, index) => (
                <div
                  className="col-lg-4 col-md-6 wow fadeInUp animated"
                  key={index}
                >
                  <div className="services-three__card">
                    {item.type !== "Achievement" && item.type !== "Event" && (
                      <a className="services-three__card__image">
                        <img
                          src={item.tournament_path + item.tournament_logo}
                          width="200px"
                          height="200px"
                          alt="logo"
                          onError={(e) => errortour(e)}
                        />
                        <img
                          src={item.tournament_path + item.tournament_logo}
                          width="200px"
                          height="200px"
                          alt="logo"
                          onError={(e) => errortour(e)}
                        />
                        <span className="services-three__card__overlay"></span>
                      </a>
                    )}
                    {item.id != 51 && item.type == "Event" && (
                      <a className="services-three__card__image">
                        <img
                          src={require("../../../../assets/images/resources/logo-pathway.png")}
                          width="200px"
                          height="200px"
                          alt="logo"
                        />
                        <img
                          src={require("../../../../assets/images/resources/logo-pathway.png")}
                          width="200px"
                          height="200px"
                          alt="logo"
                        />
                        <span className="services-three__card__overlay"></span>
                      </a>
                    )}

                    {item.id == 51 && item.type == "Event" && (
                      <a className="services-three__card__image">
                        <img
                          src={require("../../../../assets/images/harayana.jpeg")}
                          width="200px"
                          height="200px"
                          alt="logo"
                        />
                        <img
                          src={require("../../../../assets/images/harayana.jpeg")}
                          width="200px"
                          height="200px"
                          alt="logo"
                        />
                        <span className="services-three__card__overlay"></span>
                      </a>
                    )}

                    {item.type === "Achievement" && (
                      <a className="services-three__card__image">
                        <img
                          src={item.tournament_path + item.imagename}
                          width="200px"
                          height="200px"
                          alt="logo"
                          onError={(e) => errorhandle(e)}
                        />
                        <img
                          src={item.tournament_path + item.imagename}
                          width="200px"
                          height="200px"
                          alt="logo"
                          onError={(e) => errorhandle(e)}
                        />
                        <span className="services-three__card__overlay"></span>
                      </a>
                    )}
                    <div className="services-one__card__content">
                      <div onClick={() => handleShow(item)}>
                        <h4 className="text-success">{item.meet_name}</h4>
                        <h4 className="text-danger">
                          {item.start_date !== ""
                            ? moment(item.start_date).format("DD-MM-YYYY")
                            : ""}{" "}
                          -{" "}
                          {item.end_date !== ""
                            ? moment(item.end_date).format("DD-MM-YYYY")
                            : ""}
                        </h4>
                        <h4>{item.categories}</h4>
                        {item.sports_type !== "" && <h5>{item.sports_type}</h5>}
                      </div>

                      {item.gallery && (
                        <div className="text-center">
                          <a
                            className="btn btn-danger"
                            onClick={() => handleopen(item)}
                          >
                            {" "}
                            View Gallery
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {tourRecordsToShow < tolist.length && (
              <div className="form-group text-center mt-2">
                <a onClick={tourloadMore} className="btn btn-secondary">
                  Load More
                </a>
              </div>
            )}

            <hr />
          </div>
        )}

        <div
          style={{ display: tshow ? "block" : "none" }}
          className={tshow ? "modal fade show" : "modal fade"}
          id="exampleModal"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h4> {tdet.type} Details</h4>
              </div>
              <div
                className="modal-body"
                style={{ maxHeight: "60vh", overflowY: "auto" }}
              >
                <Row className="row-sm mx-0">
                  <div className="col-md-12">
                    <div className="details-group">
                      <div className="row">
                        <div className="col-md-4">
                          <b className="text-inverse">Tournament</b>
                        </div>
                        <div className="col-md-8">
                          <span className="text-inverse">{tdet.meet_name}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="details-group">
                      <div className="row">
                        <div className="col-md-4">
                          <b className="text-inverse">Start Date</b>
                        </div>
                        <div className="col-md-8">
                          <span className="text-inverse">
                            {moment(tdet.start_date).format("DD-MM-YYYY")}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  {tdet.end_date !== "" && (
                    <div className="col-md-12">
                      <div className="details-group">
                        <div className="row">
                          <div className="col-md-4">
                            <b className="text-inverse">End Date</b>
                          </div>
                          <div className="col-md-8">
                            <span className="text-inverse">
                              {moment(tdet.end_date).format("DD-MM-YYYY")}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="col-md-12">
                    <div className="details-group">
                      <div className="row">
                        <div className="col-md-4">
                          <b className="text-inverse">Categories</b>
                        </div>
                        <div className="col-md-8">
                          <span className="text-inverse">
                            {tdet.categories}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="details-group">
                      <div className="row">
                        <div className="col-md-4">
                          <b className="text-inverse">Sports</b>
                        </div>
                        <div className="col-md-8">
                          <span className="text-inverse">
                            {tdet.sports_type}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Row>
              </div>
              <div className="modal-footer">
                <a className="btn btn-danger" onClick={() => setTShow(false)}>
                  Close
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* <Modal show={tshow} size="lg">
          <Modal.Header>
            <h4> {tdet.type} Details</h4>
          </Modal.Header>
          <Modal.Body>
            <Row className="row-sm mx-0">
              <div className="col-md-12">
                <div className="details-group">
                  <div className="row">
                    <div className="col-md-4">
                      <b className="text-inverse">Tournament</b>
                    </div>
                    <div className="col-md-8">
                      <span className="text-inverse">{tdet.meet_name}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-12">
                <div className="details-group">
                  <div className="row">
                    <div className="col-md-4">
                      <b className="text-inverse">Start Date</b>
                    </div>
                    <div className="col-md-8">
                      <span className="text-inverse">
                        {moment(tdet.start_date).format("DD-MM-YYYY")}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              {tdet.end_date !== "" && (
                <div className="col-md-12">
                  <div className="details-group">
                    <div className="row">
                      <div className="col-md-4">
                        <b className="text-inverse">End Date</b>
                      </div>
                      <div className="col-md-8">
                        <span className="text-inverse">
                          {moment(tdet.end_date).format("DD-MM-YYYY")}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className="col-md-12">
                <div className="details-group">
                  <div className="row">
                    <div className="col-md-4">
                      <b className="text-inverse">Categories</b>
                    </div>
                    <div className="col-md-8">
                      <span className="text-inverse">{tdet.categories}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <div className="details-group">
                  <div className="row">
                    <div className="col-md-4">
                      <b className="text-inverse">Sports</b>
                    </div>
                    <div className="col-md-8">
                      <span className="text-inverse">{tdet.sports_type}</span>
                    </div>
                  </div>
                </div>
              </div>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <a className="btn btn-danger" onClick={() => setTShow(false)}>
              Close
            </a>
          </Modal.Footer>
        </Modal> */}

        <div
          style={{ display: show ? "block" : "none" }}
          className={show ? "modal fade show" : "modal fade"}
          id="exampleModal"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h4> Gallery</h4>
              </div>
              <div
                className="modal-body"
                style={{ maxHeight: "60vh", overflowY: "auto" }}
              >
                <div className="row">
                  <h3 className="text-center">{gtour}</h3>

                  {glist.map((item, index) => {
                    return (
                      <div className="col-md-2 mt-4" key={index}>
                        <img
                          className="photoimg"
                          src={item.src}
                          height="100px"
                          alt="Photo"
                          onClick={() => openPLightbox(index, glist)}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="modal-footer">
                <div className="text-right border-top mt-2">
                  <a className="btn btn-danger mt-2" onClick={handleclose}>
                    <i className="fa fa-times"></i> Close
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ModalGateway>
          {viewerIsOpen ? (
            <Modal onClose={closeLightbox}>
              <Carousel
                currentIndex={currentImage}
                views={pplist.map((x) => ({
                  ...x,
                  srcset: x.srcSet,
                  caption: x.title,
                }))}
              />
            </Modal>
          ) : null}
        </ModalGateway>

        {/* <Modal show={show} size="xl">
          <Modal.Header>
            <h4>Gallery</h4>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <h3 className="text-center">{gtour}</h3>

              {glist.map((item, index) => {
                return (
                  <div className="col-md-2 mt-4" key={index}>
                    <img
                      className="photoimg"
                      src={item.src}
                      height="100px"
                      alt="Photo"
                    />
                  </div>
                );
              })}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="text-right border-top mt-2">
              <a className="btn btn-danger mt-2" onClick={handleclose}>
                <i className="fa fa-times"></i> Close
              </a>
            </div>
          </Modal.Footer>
        </Modal> */}

        {sslist.length !== 0 && (
          <div className="container mt-2">
            <div className="row gutter-y-30">
              <h4>Success Stories</h4>
              {sscurrentRecords.map((item, index) => {
                return (
                  <div
                    className="col-lg-4 col-md-6 wow fadeInUp animated"
                    key={item.id}
                  >
                    <div
                      className="services-three__card"
                      onClick={() => handlestory(item.id)}
                    >
                      {" "}
                      <a className="services-three__card__image">
                        <img
                          src={spath + item.article_image}
                          width="200px"
                          height="200px"
                          alt="story"
                          onError={(e) => errortour(e)}
                        />
                        <img
                          src={spath + item.article_image}
                          width="200px"
                          height="200px"
                          alt="story"
                          onError={(e) => errortour(e)}
                        />
                        <span className="services-three__card__overlay"></span>
                      </a>
                      <div className="services-one__card__content">
                        <h4 className="text-success">{item.article_title}</h4>
                        <h4>{item.school_name}</h4>
                        <h5 className="res_description">
                          {item.article_description}
                        </h5>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {ssRecordsToShow < sslist.length && (
              <div className="form-group text-center mt-2">
                <a onClick={ssloadMore} className="btn btn-secondary">
                  Load More
                </a>
              </div>
            )}
            <hr />
          </div>
        )}

        <div
          style={{ display: sshow ? "block" : "none" }}
          className={sshow ? "modal fade show" : "modal fade"}
          id="exampleModal"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h4> Success Stories Details</h4>
              </div>
              <div
                className="modal-body"
                style={{ maxHeight: "60vh", overflowY: "auto" }}
              >
                <div className="owl-item active">
                  <div className="item">
                    <div className="testimonial-card-two @@extraClassName">
                      <div className="testimonial-card-two__inner">
                        <div className="row">
                          <div className="col-md-6">
                            <img src={sphto} width="100%" />
                          </div>
                          <div className="col-md-6">
                            <div className="testimonial-card-two__bottom">
                              <div className="testimonial-card-two__identity">
                                <h4 className="testimonial-card-two__name">
                                  {stitle}
                                </h4>
                                <p className="testimonial-card-two__quote">
                                  {sdesc}
                                </p>
                              </div>
                            </div>
                            <p className="testimonial-card-two__quote">
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: sdesc1,
                                }}
                              />
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <div className="text-right">
                  <a className="btn btn-danger" onClick={handlesclose}>
                    <i className="fa fa-times"></i> Close
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <Modal show={sshow} size="xl" onHide={handlesclose}>
          <Modal.Header>
            <h4>Success Stories Details</h4>
          </Modal.Header>
          <Modal.Body>
            <div className="owl-item active">
              <div className="item">
                <div className="testimonial-card-two @@extraClassName">
                  <div className="testimonial-card-two__inner">
                    <div className="row">
                      <div className="col-md-6">
                        <img src={sphto} width="100%" />
                      </div>
                      <div className="col-md-6">
                        <div className="testimonial-card-two__bottom">
                          <div className="testimonial-card-two__identity">
                            <h4 className="testimonial-card-two__name">
                              {stitle}
                            </h4>
                            <p className="testimonial-card-two__quote">
                              {sdesc}
                            </p>
                          </div>
                        </div>
                        <p className="testimonial-card-two__quote">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: sdesc1,
                            }}
                          />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="text-right">
              <a className="btn btn-danger" onClick={handlesclose}>
                <i className="fa fa-times"></i> Close
              </a>
            </div>
          </Modal.Footer>
        </Modal> */}
        {reslist.length !== 0 && (
          <div className="container mt-2">
            <div className="row gutter-y-30">
              <h4>Resources</h4>
              {currentRecords.map((item, index) => {
                return (
                  <div
                    className="col-lg-4 col-md-6 wow fadeInUp animated"
                    data-wow-duration="1500ms"
                    data-wow-delay="100ms"
                    key={index}
                  >
                    <div className="services-three__card">
                      <div className="photores-download">
                        {item.tag_name == "Reports" && (
                          <a className="report-toggle">
                            <div className="text-center">
                              <label
                                className="custom-switch mb-0"
                                title={
                                  item.selected_status === 1
                                    ? "Published"
                                    : "Private"
                                }
                              >
                                <input
                                  type="checkbox"
                                  name="custom-switch-checkbox"
                                  className="custom-switch-input"
                                  checked={
                                    item.selected_status === 1 ? true : false
                                  }
                                  onChange={() =>
                                    repstatus(item.selected_status, item)
                                  }
                                />

                                <span className="custom-switch-indicator"></span>
                              </label>
                            </div>
                          </a>
                        )}
                        {item.file_or_url != "url" && (
                          <a
                            onClick={() =>
                              downloaded(
                                respath + item.file_name,
                                item.file_name
                              )
                            }
                          >
                            <i className="fa fa-download fa-lg"></i>
                          </a>
                        )}
                        {item.file_or_url == "url" && (
                          <a href={item.file_name} target="_blank">
                            <i className="fa fa-download fa-lg"></i>
                          </a>
                        )}
                      </div>
                      {item.mark_as_star === 1 && (
                        <div className="photores-star">
                          <a>
                            <i className="fa fa-star fa-lg"></i>
                          </a>
                        </div>
                      )}
                      {item.file_type === "Photo" && (
                        <a
                          className="services-three__card__image"
                          onClick={() =>
                            handlepop(
                              item.file_name,
                              item.file_type,
                              item.file_or_url,
                              item.remarks,
                              item.tag_name,
                              item.school_name
                            )
                          }
                        >
                          <img
                            src={respath + item.file_name}
                            width="200px"
                            height="200px"
                            alt="business loan"
                            onError={(ev) => errorphoto(ev)}
                          />
                          <img
                            src={respath + item.file_name}
                            width="200px"
                            height="200px"
                            alt="business loan"
                            onError={(ev) => errorphoto(ev)}
                          />
                          <span className="services-three__card__overlay"></span>
                        </a>
                      )}
                      {item.file_type === "Video" && (
                        <a
                          className="services-three__card__image"
                          onClick={() =>
                            handlepop(
                              item.file_name,
                              item.file_type,
                              item.file_or_url,
                              item.remarks,
                              item.tag_name,
                              item.school_name
                            )
                          }
                        >
                          <img
                            src={require("../../../../assets/images/video.png")}
                            width="200px"
                            height="200px"
                            alt="business loan"
                          />
                          <img
                            src={require("../../../../assets/images/video.png")}
                            width="200px"
                            height="200px"
                            alt="business loan"
                          />
                          <span className="services-three__card__overlay"></span>
                        </a>
                      )}

                      {item.file_type === "PDF" && (
                        <a
                          className="services-three__card__image"
                          onClick={() =>
                            handlepop(
                              item.file_name,
                              item.file_type,
                              item.file_or_url,
                              item.remarks,
                              item.tag_name,
                              item.school_name
                            )
                          }
                        >
                          <img
                            src={require("../../../../assets/images/pdf.png")}
                            width="200px"
                            height="200px"
                            alt="business loan"
                          />
                          <img
                            src={require("../../../../assets/images/pdf.png")}
                            width="200px"
                            height="200px"
                            alt="business loan"
                          />
                          <span className="services-three__card__overlay"></span>
                        </a>
                      )}
                      <div className="services-one__card__content">
                        <h4 className="text-success">{item.school_name}</h4>
                        <h4>{item.tag_name}</h4>
                        <h5 className="res_description">{item.remarks}</h5>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {totalRecordsToShow < reslist.length && (
          <div className="form-group text-center mt-2">
            <a onClick={loadMore} className="btn btn-secondary">
              Load More
            </a>
          </div>
        )}

        <div
          style={{ display: ishow ? "block" : "none" }}
          className={ishow ? "modal fade show" : "modal fade"}
          id="exampleModal"
          tabIndex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h4> Resources</h4>
              </div>
              <div
                className="modal-body"
                style={{ maxHeight: "60vh", overflowY: "auto" }}
              >
                <Row className="row-sm mx-0">
                  <Col lg={12} md={12}>
                    <div className="form-group">
                      {pimgtype === "Video" && pimgurl === "url" && (
                        <iframe
                          width="100%"
                          height="300"
                          src={pimage}
                          frameBorder="0"
                          // allow="autoplay; encrypted-media"
                          allowFullScreen
                          title="Embedded youtube"
                        />
                      )}

                      {pimgtype === "Video" && pimgurl !== "url" && (
                        <video controls width="100%" height="300">
                          <source src={pimage} type="video/mp4" />
                        </video>
                      )}

                      {pimgtype === "PDF" && (
                        <iframe
                          width="100%"
                          height="400"
                          src={pimage}
                          allowFullScreen
                        />
                      )}

                      {pimgtype === "Photo" && (
                        <img src={pimage} alt="Photo" width="100%" />
                      )}
                    </div>
                  </Col>
                  <Col lg={12} md={12}>
                    <div className="form-group">
                      <h4 className="text-success">{psch}</h4>
                    </div>
                  </Col>
                  <Col lg={12} md={12}>
                    <div className="form-group">
                      <h4>{ptag}</h4>
                    </div>
                  </Col>
                  <Col lg={12} md={12}>
                    <div className="form-group">
                      <p>{prem}</p>
                    </div>
                  </Col>
                </Row>
              </div>
              <div className="modal-footer">
                <div className="text-right">
                  <a className="btn btn-danger" onClick={imageclose}>
                    <i className="fa fa-times"></i> Close
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <Modal show={ishow} size="lg" onHide={imageclose}>
          <Modal.Header>
            <h4> Resources</h4>
          </Modal.Header>
          <Modal.Body>
            <Row className="row-sm mx-0">
              <Col lg={12} md={12}>
                <div className="form-group">
                  {pimgtype === "Video" && pimgurl === "url" && (
                    <iframe
                      width="100%"
                      height="300"
                      src={pimage}
                      frameBorder="0"
                      // allow="autoplay; encrypted-media"
                      allowFullScreen
                      title="Embedded youtube"
                    />
                  )}

                  {pimgtype === "Video" && pimgurl !== "url" && (
                    <video controls width="100%" height="300">
                      <source src={pimage} type="video/mp4" />
                    </video>
                  )}

                  {pimgtype === "PDF" && (
                    <iframe
                      width="100%"
                      height="400"
                      src={pimage}
                      allowFullScreen
                    />
                  )}

                  {pimgtype === "Photo" && (
                    <img src={pimage} alt="Photo" width="100%" />
                  )}
                </div>
              </Col>
              <Col lg={12} md={12}>
                <div className="form-group">
                  <h4 className="text-success">{psch}</h4>
                </div>
              </Col>
              <Col lg={12} md={12}>
                <div className="form-group">
                  <h4>{ptag}</h4>
                </div>
              </Col>
              <Col lg={12} md={12}>
                <div className="form-group">
                  <p>{prem}</p>
                </div>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <a className="btn btn-danger" onClick={imageclose}>
              Close
            </a>
          </Modal.Footer>
        </Modal> */}
      </div>
    </div>
  );
};
